

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setCreateSpan.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * テキスト間にspanタグ生成
 */
const setCreateSpan = () => {
    var Span = document.querySelectorAll('.span__create');
    for (let i = 0; i < Span.length; i++) {
        var SpanContent = Span[i].textContent;
        var text = SpanContent.trim();
        var newHtml = "";
        text.split("").forEach(function (v) {
            newHtml += "<span>" + v + "</span>";
        });
        Span[i].innerHTML = newHtml;
    }
}

export { setCreateSpan }